import React, {useEffect, useRef} from "react";
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";
import {Dropdown} from "primereact/dropdown";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {classNames} from "primereact/utils";
import {setAudioControlField} from "../../../../redux/actions/actionsAudioControl";
import {InputSwitch} from "primereact/inputswitch";
import {Divider} from "primereact/divider";
import {getUsersManagerUserBranchesData} from "../../../../redux/api/apiUsersList";

const AudioControlDialogGeneralSettings = () => {
    const dispatch = useAppDispatch();
    const audioControlData = useAppSelector(state => state.AudioControlListReducer.audioControlData);
    const errorFields = useAppSelector(state => state.AudioControlListReducer.errorFields);
    const nameField = useRef<HTMLDivElement>(null);
    const editType = useAppSelector(state => state.UsersReducer.editType);
    const archiveTableToggle = useAppSelector(state => state.AudioControlListReducer.archiveAudioControlTableToggle);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const branches = useAppSelector(state => state.UsersListReducer.branches);

    useEffect(() => {
        dispatch(getUsersManagerUserBranchesData(jwtToken?.jwtToken));
    }, [dispatch, jwtToken?.jwtToken]);

    const scrollIntoNameView = () => {
        nameField.current?.scrollIntoView({behavior: 'smooth'});
    };

    useEffect(() => {
        if (!audioControlData?.name && errorFields?.name) {
            scrollIntoNameView();
        }
        if (errorFields?.nameUniq || errorFields?.branchId) {
            scrollIntoNameView();
        }
    }, [errorFields, audioControlData]);

    return (
        <div className="general-settings">
            <div className="grid p-fluid">
                <div className="field col-12 md:col-6" ref={nameField}>
                    <label htmlFor="name" className={classNames('', {'p-error': errorFields?.name || errorFields?.nameUniq})}>Назва *</label>
                    <InputText
                        id="name"
                        value={audioControlData?.name || ''}
                        maxLength={150}
                        className={classNames('', {'p-invalid': errorFields?.name || errorFields?.nameUniq})}
                        onChange={e => {
                            dispatch(setAudioControlField({fieldName: 'name', value: e.target.value}));
                        }}
                        disabled={!archiveTableToggle || !editType}
                    />
                    {errorFields?.nameUniq && <div className="col-12 md:col-12 pt-2 px-0 pb-0"><span className="title p-error text-sm">{errorFields?.nameUniq}*</span></div>}
                </div>
                <div className="field col-12 md:col-3 m-0 p-0">
                </div>
                <div className="field col-12 md:col-6">
                    <label htmlFor="description">Коментар</label>
                    <InputTextarea
                        id="description"
                        value={audioControlData?.description || ''}
                        onChange={e => {
                            dispatch(setAudioControlField({fieldName: 'description', value: e.target.value}));
                        }}
                        autoResize
                        rows={3}
                        maxLength={500}
                        disabled={!archiveTableToggle || !editType}
                    />
                </div>
                <Divider className="mx-2"/>
                <div className="field col-12 md:col-4">
                    <label
                        htmlFor="branchId"
                        className={classNames("", {
                            "p-error": errorFields?.branchId && !audioControlData?.branchId,
                        })}
                    >
                        Бранч *
                    </label>
                    <Dropdown
                        id="branchId"
                        value={audioControlData?.branchId || ''}
                        options={branches}
                        filter
                        className={classNames("w-full", {
                            "p-invalid": errorFields?.branchId && !audioControlData?.branchId,
                        })}
                        optionValue="id"
                        optionLabel="name"
                        placeholder="Виберіть бранч"
                        onChange={(e) => {
                            dispatch(setAudioControlField({fieldName: 'branchId', value: e.value}));
                        }}
                        disabled={!archiveTableToggle || !editType}
                    />
                    {errorFields?.branchId && (
                        <div className="col-12 md:col-12 pt-2 px-0 pb-0">
                            <span className="title p-error text-sm">
                                {errorFields.branchId.branchId ?? 'Виберіть бранч *'}
                            </span>
                        </div>
                    )}
                </div>
                <Divider className="mx-2"/>
                <div className="field col-12 md:col-12">
                    <label htmlFor="isActive" className="pl-2">Стан</label>
                    <div className="field-radiobutton my-4 pl-1">
                        <label htmlFor="isActive" className="mr-2 w-6rem">Не активна</label>
                        <InputSwitch
                            disabled={!archiveTableToggle || !editType}
                            className="mr-3"
                            checked={audioControlData?.isActive || false}
                            onChange={(e) => {
                                dispatch(setAudioControlField({fieldName: 'isActive', value: e.value}));
                            }}
                        />
                        <label htmlFor="isActive">Активна</label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AudioControlDialogGeneralSettings;
